<template>
  <div>
    <v-row v-if="!loadingEvent">
      <v-col
        cols="12"
        md="3"
        lg="3"
      >
        <EventBioComponent :event-data="eventData" />
      </v-col>

      <v-col
        cols="12"
        md="9"
        lg="9"
      >
        <router-view />
      </v-col>
    </v-row>
    <v-overlay :value="loadingEvent">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { fetchEvent } from '@/services/events/events.service';
import { ref, getCurrentInstance } from '@vue/composition-api';
import { useRouter } from '@core/utils';
import { ERROR_404 } from '@/router/constants';
import EventBioComponent from './EventPage/EventBio.vue';

export default {
  name: 'EventPage',
  components: { EventBioComponent },
  setup() {
    const vm = getCurrentInstance().proxy;
    const { router } = useRouter();

    // State

    const loadingEvent = ref(false);
    const eventData = ref({});

    // Methods

    const getDataEvent = async (eventId) => {
      loadingEvent.value = true;

      try {
        eventData.value = await fetchEvent(eventId);
      } catch (e) {
        router.push({ name: ERROR_404 });
      } finally {
        loadingEvent.value = false;
      }
    };

    // Created

    const { eventId } = vm.$route.params;
    getDataEvent(eventId);

    // Return

    return {
      // State
      loadingEvent,
      eventData,
    };
  },
};
</script>
